export const numericRegex = /^-?(0?\.\d*|0?[1-9]\d*\.?\d*|0|\.?)?$/
export const ipLikeRegex =
  /^(?:25[0-5]|(?:2[0-4]|1\d|[1-9]|)\d)(?:\.(?:25[0-5]|(?:2[0-4]|1\d|[1-9]|)\d)){0,2}(?:\.(?:25[0-5]|(?:2[0-4]|1\d|[1-9]|)\d)?)?$/

export function numericRegexWithPrecision(precision?: number, allowNegative: boolean = true, allowMultipleZeros: boolean = false): RegExp {
  if (precision === undefined) {
    if (allowNegative) {
      if (allowMultipleZeros) {
        return /^-?\d*.?\d*$/
      } else {
        return /^-?(0?\.\d*|0?[1-9]\d*\.?\d*|0|\.?)?$/
      }
    } else {
      if (allowMultipleZeros) {
        return /^\d*.?\d*$/
      } else {
        return /^(0?\.\d*|0?[1-9]\d*\.?\d*|0|\.?)?$/
      }
    }
  }
  if (precision <= 0) {
    if (allowNegative) {
      if (allowMultipleZeros) {
        return new RegExp(`^-?\\d*$`)
      } else {
        return new RegExp(`^-?(0?[1-9]\\d*|0)?$`)
      }
    } else {
      if (allowMultipleZeros) {
        return new RegExp(`^\\d*$`)
      } else {
        return new RegExp(`^(0?[1-9]\\d*|0)$`)
      }
    }
  } else {
    if (allowNegative) {
      if (allowMultipleZeros) {
        return new RegExp(
          `^-?(0?\\.\\d{0,${precision}}|0?[0-9]\\d*\\.?\\d{0,${precision}}|0|\\.?)$`, //TODO - can be simplified, untested
        )
      } else {
        return new RegExp(`^-?(0?\\.\\d{0,${precision}}|0?[1-9]\\d*\\.?\\d{0,${precision}}|0|\\.?)$`)
      }
    } else {
      if (allowMultipleZeros) {
        return new RegExp(`^(0?\\.\\d{0,${precision}}|0?[0-9]\\d*\\.?\\d{0,${precision}}|0|\\.?)$`) //TODO - can be simplified, untested
      } else {
        return new RegExp(`^(0?\\.\\d{0,${precision}}|0?[1-9]\\d*\\.?\\d{0,${precision}}|0|\\.?)$`)
      }
    }
  }
}

export function getPlotRefetchInterval(timeRangeSeconds: number): number {
  if (timeRangeSeconds <= 1 * 3600) {
    return 20 * 1000
  } else if (timeRangeSeconds <= 24 * 3600) {
    return 60 * 1000
  } else if (timeRangeSeconds <= 7 * 24 * 3600) {
    return 5 * 60 * 1000
  } else {
    return 10 * 60 * 1000
  }
}
